import { useBreakpoint } from '@ocean/hooks'
import { layouts } from '@ocean/tables'
import { Size } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'

const { ContentTrace, Translucent } = common.skeletonStyles
const { TableLayout, TableHead, TableHeadCol, TableBody, TableRow, TableRowCol } = layouts

const TableSkeleton: React.FC = () => {
  const isDesktop = useBreakpoint('sm')

  return (
    <Translucent opacity='0.3' data-test='TableSkeleton'>
      <TableLayout>
        <TableHead>
          <TableHeadCol width='33%'>
            <ContentTrace size={Size.Small} width='80px' color='oceanDark' />
          </TableHeadCol>
          {isDesktop && (
            <TableHeadCol width='17%' align='center'>
              <ContentTrace size={Size.Small} width='70px' color='oceanDark' />
            </TableHeadCol>
          )}
          <TableHeadCol width='17%' align='center'>
            <ContentTrace size={Size.Small} width='65px' color='oceanDark' />
          </TableHeadCol>
          <TableHeadCol width='33%' align='right'>
            <ContentTrace size={Size.Small} width='80px' color='oceanDark' />
          </TableHeadCol>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableRowCol width='33%'>
              <ContentTrace width='75%' />
            </TableRowCol>
            {isDesktop && (
              <TableRowCol width='17%' align='center'>
                <ContentTrace width='45%' />
              </TableRowCol>
            )}
            <TableRowCol width='17%' align='center'>
              <ContentTrace width='55%' />
            </TableRowCol>
            <TableRowCol width='33%' align='right'>
              <ContentTrace width='40%' />
            </TableRowCol>
          </TableRow>
          <TableRow>
            <TableRowCol width='33%'>
              <ContentTrace width='45%' />
            </TableRowCol>
            {isDesktop && (
              <TableRowCol width='17%' align='center'>
                <ContentTrace width='65%' />
              </TableRowCol>
            )}
            <TableRowCol width='17%' align='center'>
              <ContentTrace width='50%' />
            </TableRowCol>
            <TableRowCol width='33%' align='right'>
              <ContentTrace width='65%' />
            </TableRowCol>
          </TableRow>
        </TableBody>
      </TableLayout>
    </Translucent>
  )
}

export default TableSkeleton
